import { PanelType } from "@fluentui/react";
import { AppsAddIn32Filled } from "@fluentui/react-icons";
import { ReactNode } from "react";
import { CustomButtonProps } from "../Interfaces/ButtonWithPanel.interfaces";
import { CustomPanelProps } from "../Interfaces/CustomPanel.interfaces";
/**
 * Default configuration constants for ButtonWithPanel component
 */

export const BUTTON_WITH_PANEL_DEFAULTS = {
  button: {
    appearance: "subtle",
    disabled: false,
    buttonContent: "View Details",
    icon: <AppsAddIn32Filled color="var(--colorBrandBackground)" />
  } as CustomButtonProps,
  panel: {
    isLoading: false,
    panelTitle: "Details",
    panelType: PanelType.medium
  } as Omit<CustomPanelProps, "dismissPanel" | "enablePanel" | "children"> & { panelContent?: ReactNode }
};

export const defaultButtonConfig = BUTTON_WITH_PANEL_DEFAULTS.button;
export const defaultPanelConfig = BUTTON_WITH_PANEL_DEFAULTS.panel;
